import React, { useState } from 'react';
import styled from 'styled-components'
import { Icon } from '@iconify/react';
import vibrationIconNative from '../../../images/icons/vibration.png'
import vibrationProfoundIconNative from '../../../images/icons/vibrationProfound.png'
import noiseIconNative from '../../../images/icons/noise.png'
import weatherIconNative from '../../../images/icons/weather.png'
import dustIconNative from '../../../images/icons/dust.png'
import connectionIcon from '@iconify/icons-icomoon-free/connection';
import disconnectedSolid from '@iconify/icons-clarity/disconnected-solid';
import { colour_lookup, connectivity_colour_lookup } from '../../common/Colours';
import { isUndefinedOrNull } from '../../../lib/typeCheck';
import chevronLeft from '@iconify/icons-carbon/chevron-left';
import chevronRight from '@iconify/icons-carbon/chevron-right';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPositionSamples, fetchPositionTimePeriods, togglePositionStatusBoxDisplay, toggleSelected } from '../../../store/positions/positionsSlice';
import { updateZoom } from '../../../store/devices/mapSettingsSlice';
import { findBounds } from '../../../lib/map';
import { getHost } from '../../../api/host';
import { getFilterStatus } from '../../../store/positions/filterStatusSlice';

const StyledSiteClusterMarker = styled.div<{isHovered}>`
  position: absolute;
  transform: translate(-50%, -66%);
  width: 120px;
  height: 140px;
  background: '#ddd';
  // cursor: pointer;
  pointer-events: none;
  z-index: 98;
  z-index: ${({ isHovered }) => (isHovered ? 99 : 'auto')};
`;

const StyledTooltip = styled.div<{isVisible}>`
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  pointer-events: none;
  opacity: ${props => props.isVisible ? 1 : 0};
  transition: opacity 0.2s;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 10px;
  z-index: 1000;
  display: inline-block; /* Ensures the width adjusts to the text length */
  white-space: nowrap;  /* Prevents the text from wrapping */

`;

const StyledPositionCountText = styled.text`
  fill: white;
  font-size: 16px;
  text-anchor: middle;
  transform: translateY(-9px)
`;

const StyledPositionMapMarker = styled.div<{isHovered}>`
  position: absolute;
  transform: translate(-50%, -120%);
  width: 260px;
  // cursor: pointer;
  pointer-events: none;
  z-index: ${({ isHovered }) => (isHovered ? 99 : 'auto')};
`;
const StyledArrowDown = styled.div<{size : number, color : string, translateX : number, translateY : number}>`
  width: 0; 
  height: 0; 
  border-left: ${props => props.size}px solid transparent;
  border-right: ${props => props.size}px solid transparent;
  border-top: ${props => props.size}px solid ${props => props.color};
  transform: translate(${props => props.translateX}px, ${props => props.translateY}px);
`
const StyledCircleMarker = styled.div`
  height: 15px;
  width: 15px;
  background-color: #233567;
  border-radius: 50%;
  // transform: rotateX(60deg) rotateY(0deg) rotateZ(-45deg) translate(-127px,300px);
  transform: translate(122.5px,150px);
`
const StyledMarkerContainer = styled.div<{isHovered}>`
  background-color: #FFF;
  display:flex;
  flex-direction: column;
  align-items:center;
  border-radius: 5px;
  border: 2px solid #ddd;
  pointer-events: auto;
  cursor: pointer;
  position: relative;
  // opacity: ${({ isHovered }) => (isHovered ? 1 : 0.5)};
  z-index: ${({ isHovered }) => (isHovered ? 99 : 'auto')};
`
const MultiStyledMarkerContainer = styled(StyledMarkerContainer)`
  transform: translate(0px, -8px);
  pointer-events: auto;
  cursor: pointer;

  z-index: ${({ isHovered }) => (isHovered ? 99 : 'auto')};
`
const StyledMarkerSpan = styled.span`
  padding: 4px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:hover{
    opacity: 60%;
  }
`
const StyledTable = styled.table`
  background-color: #FFF;
  height: 100%;
  width: 200px;
`
const StyledTableDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding: 6px;
`
const StyledH3 = styled.h3`
  &:hover{
    opacity: 60%;
  }
`
const StyledTableTH = styled.th`
  vertical-align: middle;
  // width: 33%;
`
const StyledTableTD = styled.td`
  vertical-align: middle;
  text-align: center;
  padding: 2px;
`
const StyledTableTR = styled.tr`
  height: 20px;
`
const StyledSVG = styled.svg`
  display: flex;
  vertical-align: middle;
`
const icon_lookup = [
  '',
  [noiseIconNative, noiseIconNative],
  [vibrationProfoundIconNative, vibrationIconNative, vibrationIconNative, vibrationIconNative, vibrationIconNative, vibrationIconNative],
  [dustIconNative, dustIconNative],
  [weatherIconNative]
]

const StyledProgressBar = styled.div`
  width: 60%;
  height: 4px;
  margin-bottom: 4px;
  border-radius: 10px;
  background-color: #cfcfcf;
  position: relative;
`

const StyledProgressBarProgress = styled.div<{currentIndex, childClusters}>`
  height: 100%;
  width: ${props => (props.currentIndex / props.childClusters.length) * 100}%;
  border-radius: 10px 0px 0px 10px;
  background-color: #233567;
  position: absolute;
`

const StyledPreviousButton = styled.a<{isHovered}>`
  font-size: 1.5rem;
  background-color: white;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border: 1px solid #ddd;
  // transform: translate(-28px, -70px);
  transform: translate(-162px, -96px);
  position: absolute;
  cursor: pointer;
  z-index: ${({ isHovered }) => (isHovered ? 99 : 'auto')};
  &:hover .icon{
    opacity: 50%;
  }
`
const StyledNextButton = styled.a<{isHovered}>`
  font-size: 1.5rem;
  background-color: white;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border: 1px solid #ddd;
  // transform: translate(257px, -70px);
  transform: translate(129px, -96px);
  position: absolute;
  cursor: pointer;
  z-index: ${({ isHovered }) => (isHovered ? 99 : 'auto')};
  &:hover .icon{
    opacity: 50%;
  }
`

const MoreDetails = styled.a`
  padding: 4px 10px;
  background: #233567;
  border-radius: 3px;
  cursor: pointer;
  color: #FFF;

  &:hover {
    opacity: 60%;
  }
  
  a {
    cursor: pointer;
    color: #FFF;
    text-decoration: none;
    text-align: center;
  }
`;

const shortenText = (text, length) => {
  return `${text.slice(0,length)}${text.length > length? '...' : ''}`;
}

const calculateIconLocation = (points, point_position) => {
  let arc_range = (points - 1)/3;
  let radius = 40;
  let offset = { x: 45, y: 40 }
  let slice = arc_range * Math.PI / (points - 1);

  let angle = (point_position * slice);
  if (points === 1) angle += slice;
  if (points === 2) angle -= slice * 2;
  if (points === 3) angle -= slice * 2.5;
  if (points === 4) angle -= slice * 3;
  if (points === 5) angle -= slice * 3.5;

  return {
    x: offset.x + (radius * Math.cos(angle)),
    y: offset.y + (radius * Math.sin(angle))
  }
}

const getIconLocations = (settings) => {

  const icon_count = Object.values(settings).filter(value => value).length;

  return {
    connectivity: calculateIconLocation(icon_count, 0),
    exceedances: calculateIconLocation(icon_count, 1),
    battery: calculateIconLocation(icon_count, 2),
    tunnel: calculateIconLocation(icon_count, 3)
  }
}

const getConnectivityIcon = (online_status) => {
  if (isUndefinedOrNull(online_status)) return disconnectedSolid;
  
  if (online_status === 'offline' || online_status === 'not_measuring') {
    return disconnectedSolid;
  } else {
    return connectionIcon;
  }
}

// Renders the instrument icon
export const PositionMapClusterMarker = ({ key, lat, lng, position, onClick, settings, label, cluster, pointCount, displayData, childClusters }: { key: any; lat: number; lng: number; position: any; onClick?: any; settings: any; label: any; cluster: any; pointCount: number; displayData: boolean; childClusters: any; }) => {
  // Get current filter status
  const currentStatus = useSelector(getFilterStatus);

  const [isHovered, setIsHovered] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  function nextSlide(currentIndex, childClusters) {
    const nextIndex = (currentIndex + 1) % childClusters.length;
    setCurrentIndex(nextIndex);
  }
  
  function previousSlide(currentIndex, childClusters) {
    const previousIndex = (currentIndex - 1 + childClusters.length) % childClusters.length;
    setCurrentIndex(previousIndex);
  }

  const dispatch = useDispatch()
  const positionZoom = (currentIndex, childClusters) => {
    return() => {
      // console.log("doing more things");
      // console.log(childClusters);
      // console.log(currentIndex);
      // console.log(childClusters[0]);
      dispatch(togglePositionStatusBoxDisplay(childClusters[currentIndex].station_id));    
      dispatch(toggleSelected({id: childClusters[currentIndex].id}));
      dispatch(fetchPositionSamples(childClusters[currentIndex]));
      dispatch(fetchPositionTimePeriods(childClusters[currentIndex]));
      // dispatch(updateZoom(findBounds(childClusters, 700, 500, 17)));
    }
  }

  const makeGraphUrl = (position) => {
    if (position.type_id === 2 && position.subtype_id === 0) return `https://${getHost()}/ppv/overview/${position.station_id}`;
    return `https://${getHost()}/positions/graph/${position.station_id}`;
  }

  if(pointCount > 0 && displayData === false && childClusters === null){
    const largePointCountCalc = (pointCount) => {
      const largeRadiusCalc = 25 + Math.log(pointCount + 1) * 2;
      const result = Math.min(largeRadiusCalc, 50);
      // console.log(result);
      return result
    }
    const smallPointCountCalc = (pointCount) => {
      const smallRadiusCalc = 20 + Math.log(pointCount + 1) * 2;
      const result = Math.min(smallRadiusCalc, 50);
      // console.log(result);
      return result
    }

    return(
      <div style={{ position: 'relative' }}>
        <StyledSiteClusterMarker 
          onMouseEnter={() => setIsHovered(true)} 
          onMouseLeave={() => setIsHovered(false)} 
          isHovered={isHovered}
        >  
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 140' style={{pointerEvents: "none"}}>
            <filter id="shadow">
              <feDropShadow dx="0" dy="2" stdDeviation="0.9"/>
            </filter>
            <filter id="shadowSmall">
              <feDropShadow dx="0" dy="1.5" stdDeviation="0.9"/>
            </filter>
    
            <circle cx='60' cy='55' r={largePointCountCalc(pointCount)} fill={colour_lookup('white')} style={{filter: 'url(#shadowSmall)', pointerEvents: "auto", cursor: "pointer"}} onClick={() => { onClick(cluster) }}/>
            <circle cx='60' cy='55' r={smallPointCountCalc(pointCount)} fill={colour_lookup('dark_blue')} style={{filter: 'url(#shadowSmall)', pointerEvents: "auto", cursor: "pointer"}} onClick={() => { onClick(cluster) }}/>
            {(pointCount &&
              <StyledPositionCountText x='60' dy='70' style={{pointerEvents: "auto", cursor: "pointer"}} onClick={() => { onClick(cluster) }}>{pointCount}P</StyledPositionCountText>
            )}
          </svg>
        </StyledSiteClusterMarker>
        
        <StyledTooltip isVisible={isHovered}>
          {pointCount} Positions in this cluster
        </StyledTooltip>
      </div>
      )
  } else 
  if(displayData === true && childClusters === null){
    const connectivity_colour = connectivity_colour_lookup(position.status.online_status);
    const exceedances_total_colour = colour_lookup(position.status.exceedance_level_total || 'green');
    const exceedances_now_colour = colour_lookup(position.status.exceedance_level_now || 'green');
    const battery_colour = colour_lookup(position.status.charge_status || 'light_grey');

    const isVisibleOnline = (position.status.online_status !== 'offline' && position.status.online_status !== 'not_measuring') && currentStatus != 'offline';
    const isVisibleOffline = (position.status.online_status === 'offline' || position.status.online_status === 'not_measuring') && currentStatus === 'offline';
    const isVisibleAll = currentStatus === 'all';
    
    const isVisible = isVisibleOnline || isVisibleOffline || isVisibleAll;

    if(isVisible){
      return(
        <StyledPositionMapMarker onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} isHovered={isHovered}>
          <StyledCircleMarker/>
          <StyledArrowDown size={20} color={'#ddd'} translateX={110} translateY={123}/>
          <StyledArrowDown size={20} color={'#fff'} translateX={110} translateY={101}/>
          <StyledMarkerContainer onClick={() => { onClick(position) }} isHovered={isHovered}>
            <StyledTableDiv><StyledH3>{shortenText(position.title,29)}</StyledH3> <MoreDetails onClick={(e) => { e.preventDefault(); window.open(makeGraphUrl(position), "_blank"); }}>Detailed View</MoreDetails></StyledTableDiv>
            <StyledMarkerSpan>
              <StyledSVG xmlns='http://www.w3.org/2000/svg' height='40' width='40'>
                <image height='40' width='40' style={{margin: "0 auto", objectFit:"contain"}} href={icon_lookup[position.type_id][position.subtype_id]}/>
              </StyledSVG>
              <StyledTable>
                <thead>
                  <StyledTableTR>
                    <StyledTableTH>Status</StyledTableTH>
                    <StyledTableTH>Exceedances</StyledTableTH>
                    <StyledTableTH>Voltage</StyledTableTH>
                  </StyledTableTR>
                </thead>
                <tbody>
                    <StyledTableTR key={position.id}>
                      <StyledTableTD>
                        <Icon color={connectivity_colour} width='20px' height='20px' icon={position.status.online_status === 'offline' || position.status.online_status === 'not_measuring'? disconnectedSolid : connectionIcon}/>
                      </StyledTableTD>
                      <StyledTableTD>
                        <div style={{display: "flex", flexDirection: "row"}}>
                        <p style={{backgroundColor: exceedances_total_colour, width: "50%", borderRadius: "5px 0 0 5px", marginRight: "1px", padding: "3px 0px"}}>{position.status.exceedances_total == null? "N/a" : position.status.exceedances_total}</p>
                          <p style={{backgroundColor: exceedances_now_colour, width: "50%", borderRadius: "0 5px 5px 0", marginLeft: "1px", padding: "3px 0px"}}>{position.status.exceedances_now == null? "N/a" : position.status.exceedances_now}</p>
  
                        </div>
                      </StyledTableTD>
                      <StyledTableTD>
                        <p style={{backgroundColor: battery_colour, borderRadius: "5px", padding: "3px 0px"}}>{position.status.voltage ==null? "N/a" : position.status.voltage.toFixed(1)}</p>
                      </StyledTableTD>
                    </StyledTableTR>
                </tbody>
              </StyledTable>
            </StyledMarkerSpan>
          </StyledMarkerContainer>
        </StyledPositionMapMarker>
      )
    } else {
      return null;
    }

  } 
  else if(displayData === true && childClusters.length > 0){
    if(childClusters[currentIndex] != undefined && childClusters[currentIndex].status){
      const connectivity_colour = connectivity_colour_lookup(childClusters[currentIndex].status.online_status);
      const exceedances_total_colour = colour_lookup(childClusters[currentIndex].status.exceedance_level_total || 'green');
      const exceedances_now_colour = colour_lookup(childClusters[currentIndex].status.exceedance_level_now || 'green');
      const battery_colour = colour_lookup(childClusters[currentIndex].status.charge_status || 'light_grey');
  
      return(
          <>
          <div onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <StyledPositionMapMarker isHovered={isHovered}>
              <StyledCircleMarker/>
              <StyledArrowDown size={20} color={'#ddd'} translateX={110} translateY={123}/>
              <StyledArrowDown size={20} color={'#fff'} translateX={110} translateY={101}/>
              <MultiStyledMarkerContainer onClick={(e) => {e.preventDefault(); dispatch(togglePositionStatusBoxDisplay(childClusters[currentIndex].station_id)); dispatch(toggleSelected({id: childClusters[currentIndex].id})) } } isHovered={isHovered}>
                <StyledTableDiv><StyledH3>{shortenText(childClusters[currentIndex].title,29)}</StyledH3> <MoreDetails onClick={(e) => { e.preventDefault(); window.open(makeGraphUrl(childClusters[currentIndex]), "_blank"); }}>Detailed view</MoreDetails></StyledTableDiv>

                <StyledMarkerSpan>
                  <StyledSVG xmlns='http://www.w3.org/2000/svg' height='40' width='40'>
                    <image height='40' width='40' style={{margin: "0 auto", objectFit:"contain"}} href={icon_lookup[childClusters[currentIndex].type_id][childClusters[currentIndex].subtype_id]}/>
                  </StyledSVG>
                  <StyledTable>
                    <thead>
                      <StyledTableTR>
                        <StyledTableTH>Status</StyledTableTH>
                        <StyledTableTH>Exceedances</StyledTableTH>
                        <StyledTableTH>Voltage</StyledTableTH>
                      </StyledTableTR>
                    </thead>
                    <tbody>
                        <StyledTableTR key={childClusters[currentIndex].id}>
                          <StyledTableTD>
                            <Icon color={connectivity_colour} width='20px' height='20px' icon={childClusters[currentIndex].status.online_status === 'offline' || childClusters[currentIndex].status.online_status === 'not_measuring'? disconnectedSolid : connectionIcon}/>
                          </StyledTableTD>
                          <StyledTableTD>
                            <div style={{display: "flex", flexDirection: "row"}}>
                            <p style={{backgroundColor: exceedances_total_colour, width: "50%", borderRadius: "5px 0 0 5px", marginRight: "1px", padding: "3px 0px"}}>{childClusters[currentIndex].status.exceedances_total == null? "N/a" : childClusters[currentIndex].status.exceedances_total}</p>
                              <p style={{backgroundColor: exceedances_now_colour, width: "50%", borderRadius: "0 5px 5px 0", marginLeft: "1px", padding: "3px 0px"}}>{childClusters[currentIndex].status.exceedances_now == null? "N/a" : childClusters[currentIndex].status.exceedances_now}</p>
      
                            </div>
                          </StyledTableTD>
                          <StyledTableTD>
                            <p style={{backgroundColor: battery_colour, borderRadius: "5px", padding: "3px 0px"}}>{childClusters[currentIndex].status.voltage ==null? "N/a" : childClusters[currentIndex].status.voltage}</p>
                          </StyledTableTD>
                        </StyledTableTR>
                    </tbody>
                  </StyledTable>
                </StyledMarkerSpan>
                <StyledProgressBar>
                  <StyledProgressBarProgress currentIndex={currentIndex} childClusters={childClusters}/>
                </StyledProgressBar>
              </MultiStyledMarkerContainer>
            </StyledPositionMapMarker>
  
            <StyledPreviousButton onClick={() => {previousSlide(currentIndex, childClusters)}} isHovered={isHovered}>
              <Icon className="icon" icon={chevronLeft} style={{fill: "#D0D3D9", display: "flex", margin: "4px", marginRight: "3px"}}/>
            </StyledPreviousButton>
            <StyledNextButton onClick={() => {nextSlide(currentIndex, childClusters)}} isHovered={isHovered}>
              <Icon className="icon" icon={chevronRight} style={{fill: "#D0D3D9", display: "flex", margin: "4px", marginLeft: "3px"}}/>
            </StyledNextButton>
          </div>
          </>
      )
    } else {
      return null;
    }

  } else {
    return null;
  }
}
